module.exports = __webpack_public_path__ + "static/media/0_2019_07_20.7d3975bf.jpg";